import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BsGrid3X3Gap, BsMap } from "react-icons/bs";
import { TfiLayoutAccordionSeparated } from "react-icons/tfi";

/**
 * LayoutToggle Component
 * 
 * Provides button controls to toggle between different layout modes:
 * - grid-only: Shows only the grid/table in full width
 * - split: Shows grid (70%) and map (30%) side by side
 * - map-only: Shows only the map in full width
 * 
 * @param {string} layoutMode - Current layout mode ('split' | 'grid-only' | 'map-only')
 * @param {function} onLayoutChange - Callback when layout mode changes
 * @param {object} style - Optional custom styles for the container
 */
export function LayoutToggle({ layoutMode = "split", onLayoutChange, style = {} }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 10,
        marginTop: 12,
        marginBottom: 12,
        marginRight: 8,
        ...style,
      }}
    >
      {/* Grid Only Button */}
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-grid-only">Apenas Grid</Tooltip>}
      >
        <button
          type="button"
          className={`btn ${
            layoutMode === "grid-only"
              ? "btn-primary"
              : "btn-outline-secondary"
          }`}
          onClick={() => onLayoutChange("grid-only")}
          style={{ padding: "6px 12px", fontSize: "11px" }}
          aria-label="Show only grid"
        >
          <BsGrid3X3Gap size={18} />
        </button>
      </OverlayTrigger>

      {/* Split View Button */}
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-split">Grid + Mapa</Tooltip>}
      >
        <button
          type="button"
          className={`btn ${
            layoutMode === "split"
              ? "btn-primary"
              : "btn-outline-secondary"
          }`}
          onClick={() => onLayoutChange("split")}
          style={{ padding: "6px 12px", fontSize: "11px" }}
          aria-label="Show grid and map side by side"
        >
          <TfiLayoutAccordionSeparated size={18} />
        </button>
      </OverlayTrigger>

      {/* Map Only Button */}
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-map-only">Apenas Mapa</Tooltip>}
      >
        <button
          type="button"
          className={`btn ${
            layoutMode === "map-only"
              ? "btn-primary"
              : "btn-outline-secondary"
          }`}
          onClick={() => onLayoutChange("map-only")}
          style={{ padding: "6px 12px", fontSize: "11px" }}
          aria-label="Show only map"
        >
          <BsMap size={18} />
        </button>
      </OverlayTrigger>
    </div>
  );
}

export default LayoutToggle;
